import React, { useContext, useEffect, useState } from 'react'
import { UserContext } from '../../App'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { LoadingFull } from '../../components/loading';

export default function ProfileSettings() {

  const { user, setUser } = useContext(UserContext)
  const userId = user._id
  const stripeId = user.stripeId
  const token = localStorage.getItem('token')

  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [addresses, setAddresses] = useState([]);
  const [address, setAddress] = useState({});
  const [name, setName] = useState();
  const [first_name, setFirst_Name] = useState();
  const [last_name, setLast_Name] = useState();
  const [phone, setPhone] = useState();
  const [day, setDay] = useState();
  const [month, setMonth] = useState();
  const [year, setYear] = useState();
  const [date, setDate] = useState();
  const [editName, setEditName] = useState(true);
  const navigate = useNavigate()

  function handleChange(setValue, e, i) {
    const { maxLength, value, name } = e.target
    setValue(value)
    if (value.length === maxLength) {
      if (i !== 3) {
        document.getElementById(`field-${i+1}`).focus()
      }
    }
    if (document.getElementById('field-1').value.length === 2) {
      if (document.getElementById('field-2').value.length === 2) {
        if (document.getElementById('field-3').value.length === 4) {
          setDate(`${document.getElementById('field-3').value}-${document.getElementById('field-2').value}-${document.getElementById('field-1').value}`)
        } else {
          setDate()
        }
      } else {
        setDate()
      }
    } else {
      setDate()
    }
  }

  function updateAddress() {
    setSuccessMessage(true)
    if ('line1' && 'postal_code' && 'city' in address || typeof first_name !== 'undefined' || typeof last_name !== 'undefined' || typeof date !== 'undefined' || typeof phone !== 'undefined') {
      let values = {}
      let newDate = []
      if (typeof first_name !== 'undefined' && first_name !== '') {
        values['first_name'] = first_name
      }
      if (typeof last_name !== 'undefined' && last_name !== '') {
        values['last_name'] = last_name
      }
      if (typeof phone !== 'undefined' && phone !== '') {
        values['phone'] = '+45'+phone
      }
      if (typeof date !== 'undefined') {
        newDate = date.split('-')
        values['dob'] = {
          'day': newDate[2],
          'month': newDate[1],
          'year': newDate[0]
        }
      }
      if ('line1' && 'postal_code' && 'city' in address) {
        values['address'] = {
          'line1': address.line1,
          'postal_code': address.postal_code,
          'city': address.city
        }
      }
      axios({
        method: 'post',
        url: '/api/setAddress',
        data: {
            userId,
            stripeId,
            values
        },
        headers: {
            Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        setUser(prevUser => ({
          ...prevUser,
          ...response.data
        }));
        setSuccessMessage('Ændringerne er gemt!')
        setEditName(true)
        setAddress({})
        setName()
        setDate()
      })
      .catch(error => {
        console.log(error);
      });
    } else {
      setSuccessMessage('Ændringerne er gemt!')
      setEditName(true)
    }
  }

  function updateFields(address) {
    setAddresses([])
    if (address.etage !== null) {
      if (address.dør !== null) {
        document.getElementById('line1').value = address.adresseringsvejnavn + ' ' + address.husnr + ', ' + address.etage + '. ' + address.dør
      } else {
        document.getElementById('line1').value = address.adresseringsvejnavn + ' ' + address.husnr + ', ' + address.etage + '.'
      }
    } else {
      document.getElementById('line1').value = address.adresseringsvejnavn + ' ' + address.husnr
    }
    document.getElementById('postal_code').value = address.postnr
    document.getElementById('city').value = address.postnrnavn
    setAddress({
      'line1': document.getElementById('line1').value,
      'postal_code': address.postnr,
      'city': address.postnrnavn
    })
  }

  function getAddresses(query) {
    if (query !== '') {
      axios.get(`https://api.dataforsyningen.dk/adresser/autocomplete?q=${query}&type=adresse`, {
      })
      .then(response => {
        setAddresses(response.data);
      })
      .catch(error => {
        console.log(error);
      });
    }
  }

  return (
    <div className="flex gap-5">
      <div className="bookInfo flex items-center gap-10 shadow-lg w-full">
        <div className="bookDetails w-full flex-wrap px-5 md:px-10">
          <div className="py-5">
            <h2 className="font-semibold text-sm md:text-base">Profilindstillinger</h2>
          </div>
          {(typeof user !== 'undefined') ?
            <>
              <div className="py-5 flex flex-col gap-4">
                <div className="title w-full flex flex-col md:flex-row lg:flex-col xl:flex-row gap-y-2 justify-between items-start md:items-center lg:items-start xl:items-center">
                  <p className="flex-[1] font-medium">Fornavn</p>
                  <div className="w-full flex-[1] flex gap-2 items-center border-b border-neutral-200 relative">
                    <input type="text" id="first_name" autoComplete='none' onChange={(e) => setFirst_Name(e.target.value)} disabled={editName} defaultValue={user.first_name} className="block focus:outline-none p-4 text-sm text-gray-900 w-full" required />
                    {(editName) ?
                      <p className="text-sm text-blue-900 cursor-pointer absolute right-4" onClick={() => setEditName(false)}>Rediger</p>
                    :
                      ""
                    }
                  </div>
                </div>
                <div className="title w-full flex flex-col md:flex-row lg:flex-col xl:flex-row gap-y-2 justify-between items-start md:items-center lg:items-start xl:items-center">
                  <p className="flex-[1] font-medium">Efternavn</p>
                  <div className="w-full flex-[1] flex gap-2 items-center border-b border-neutral-200 relative">
                    <input type="text" id="last_name" autoComplete='none' onChange={(e) => setLast_Name(e.target.value)} disabled={editName} defaultValue={user.last_name} className="block focus:outline-none p-4 text-sm text-gray-900 w-full" required />
                  </div>
                </div>
              </div>
              <div className="py-5 flex flex-col gap-4 border-t border-neutral-100">
                <div className="title w-full flex flex-col md:flex-row lg:flex-col xl:flex-row gap-y-2 justify-between items-start md:items-center lg:items-start xl:items-center">
                  <p className="flex-[1] font-medium">Email</p>
                  <div className="w-full flex-[1] flex gap-2 items-center border-b border-neutral-200 relative">
                    <input type="email" id="email" autoComplete='none' disabled defaultValue={user.email} className="block focus:outline-none p-4 text-sm text-gray-900 w-full" required />
                  </div>
                </div>
                <div className="title w-full flex flex-col md:flex-row lg:flex-col xl:flex-row gap-y-2 justify-between items-start md:items-center lg:items-start xl:items-center">
                  <p className="flex-[1] font-medium">Mobil</p>
                  <div className="w-full flex-[1] flex items-center border-b border-neutral-200 relative">
                    <label className="block focus:outline-none pl-4 text-sm">+45</label>
                    <input type="text" id="phone" maxLength="11" autoComplete='none' onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/gi, "").replace(/(\d{2})(?=\d)/g, "$1 ")} onChange={(e) => setPhone(e.target.value.replace(/ /g, ''))} defaultValue={('phone' in user) ? String(user.phone).slice(2).replace(/\d{2}(?=.)/g, '$& ') : ""} className="block focus:outline-none p-4 text-sm text-gray-900 w-full" required />
                  </div>
                </div>
                <div className="title w-full flex flex-col md:flex-row lg:flex-col xl:flex-row gap-y-2 justify-between items-start md:items-center lg:items-start xl:items-center">
                  <p className="flex-[1] font-medium">Fødselsdagsdato</p>
                  <div className="w-full flex-[1] flex gap-2 items-center relative">
                    <input type="text" id="field-1" defaultValue={('dob' in user) ? (user['dob'] !== null) ? user.dob.day : "" : ""} onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/gi, "")} maxLength="2" placeholder="DD" className="text-center flex-[1] w-full border-b border-neutral-200 block focus:outline-none p-4 text-sm text-gray-900" onChange={(e) => handleChange(setDay, e, 1)} />
                    <input type="text" id="field-2" defaultValue={('dob' in user) ? (user['dob'] !== null) ? user.dob.month : "" : ""} onKeyUp={(e) => (e.key === 'Backspace') ? (e.target.value.length === 0) ? document.getElementById('field-1').focus() : "" : ""} onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/gi, "")} maxLength="2" placeholder="MM" className="text-center flex-[1] w-full border-b border-neutral-200 block focus:outline-none p-4 text-sm text-gray-900" onChange={(e) => handleChange(setMonth, e, 2)} />
                    <input type="text" id="field-3" defaultValue={('dob' in user) ? (user['dob'] !== null) ? user.dob.year : "" : ""} onKeyUp={(e) => (e.key === 'Backspace') ? (e.target.value.length === 0) ? document.getElementById('field-2').focus() : "" : ""} onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/gi, "")} maxLength="4" placeholder="YYYY" className="text-center flex-[2] w-full border-b border-neutral-200 block focus:outline-none p-4 text-sm text-gray-900" onChange={(e) => handleChange(setYear, e, 3)} />
                  </div>
                </div>
              </div>
              <div className="py-5 flex flex-col gap-4 border-t border-neutral-100">
                <div className="title w-full flex flex-col md:flex-row lg:flex-col xl:flex-row gap-y-2 justify-between items-start md:items-center lg:items-start xl:items-center">
                  <p className="flex-[1] font-medium">Gadenavn</p>
                  <div className="w-full flex-[1] relative">
                    <input type="text" id="line1" autoComplete='none' onChange={(e) => getAddresses(e.target.value)} defaultValue={('address' in user) ? user.address.line1 : ""} className="block focus:outline-none p-4 text-sm text-gray-900 border-b border-neutral-200 w-full" required />
                    <div className="z-10 absolute w-full max-h-56 overflow-auto bg-white">
                      <ul>
                        {
                          addresses.map((address) => {
                            return (
                              <li className="ps-4 py-2 hover:bg-neutral-100 cursor-pointer" onClick={() => updateFields(address.adresse)}>{address.tekst}</li>
                            )
                          })
                        }
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="title w-full flex flex-col md:flex-row lg:flex-col xl:flex-row gap-y-2 justify-between items-start md:items-center lg:items-start xl:items-center">
                  <p className="flex-[1] font-medium">Postnummer</p>
                  <div className="w-full flex-[1] relative">
                    <input type="text" id="postal_code" autoComplete='none' disabled defaultValue={('address' in user) ? user.address.postal_code : ""} className="block focus:outline-none p-4 text-sm text-gray-900 border-b border-neutral-200 w-full" required />
                  </div>
                </div>
                <div className="title w-full flex flex-col md:flex-row lg:flex-col xl:flex-row gap-y-2 justify-between items-start md:items-center lg:items-start xl:items-center">
                  <p className="flex-[1] font-medium">By</p>
                  <div className="w-full flex-[1] relative">
                    <input type="text" id="city" autoComplete='none' disabled defaultValue={('address' in user) ? user.address.city : ""} className="block focus:outline-none p-4 text-sm text-gray-900 border-b border-neutral-200 w-full" required />
                  </div>
                </div>
              </div>
              <div className="flex justify-end items-center gap-x-5 flex-wrap">
                {(successMessage === true) ? 
                  <svg aria-hidden="true" class="w-5 h-5 text-gray-200 animate-spin dark:text-gray-600 fill-white" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                      <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                  </svg>
                : (successMessage !== '') ? <h2 className="text-emerald-600">{successMessage}</h2> : ""}
                <div className="button my-5 bg-gradient-to-r from-emerald-500 to-emerald-800 transition-[] bg-size-200 bg-pos-0 hover:bg-pos-100 p-4 text-white w-min text-nowrap cursor-pointer" onClick={() => updateAddress()}>Gem ændringer</div>
              </div>
            </>
          :
            <div className="p-5">
              <LoadingFull />
            </div>
          }
        </div>
      </div>
    </div>
  )
}